import Me from "../../img/3.jpg";
import "./about.css";

const About = () => {
  return (
    <div className="a">
      <div className="a-left">
        <div className="a-card bg"></div>
        <div className="a-card">
          <img src={Me} alt="" className="a-img" />
        </div>
      </div>
      <div className="a-right">
        <h1 className="a-title">About Me</h1>
        <p className="a-sub">
          MY NAME IS RAHMAT SAEEDI, GRADUATED FROM GUJARAT UNIVERSITY, NDIA, I
          WORKED WITH MANY GOVERMENTAL AND NON-GOVERMENTAL ORGANIZATIONS AS
          SENIOR PROGRAMMING EXPERT.
        </p>
        <hr />
        <div className="a-award">
          <h4 className="a-award-title">Technical Skills</h4>
          <div className="skills">
            <div className="col1">
              <div className="skill">HTML</div>
              <div className="skill">CSS</div>
              <div className="skill">ReactJS</div>
              <div className="skill">JavaScript</div>
            </div>
            <div className="col2">
              <div className="skill">PHP</div>
              <div className="skill">Laravel</div>
              <div className="skill">Express JS</div>
              <div>NextJS</div>
            </div>
            <div className="col4">
              <div>Python</div>
              <div>Django</div>
              <div>Django-rest Framework</div>
              <div>MongoDB</div>
            </div>
            <div className="col3">
              <div>MySQL</div>
              <div>SQL Server</div>
              <div>ORACLE</div>
              <div>SqlLite</div>
            </div>
            <div className="col4">
              <div>Git & GitHub</div>
              <div>Bootstrap</div>
              <div>TailwindCSS</div>
              <div>Firebase</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
